import React from 'react';
import { useDraggable } from '@dnd-kit/core';
import { Button } from "react-bootstrap";


export function Draggable(props) {
  const { attributes, listeners, setNodeRef, transform } = useDraggable({
    id: props.id || 'draggable',
    data: props.data || undefined
  });
  const style = transform ? {
    transform: `translate3d(${transform.x}px, ${transform.y}px, 0)`
  } : undefined;


  return (
    <Button size='sm' variant="success" className="mt-1 mb-1 m-l-0-5  m-r-0-5" ref={setNodeRef} style={style} {...listeners} {...attributes}>
      {props.children}
    </Button>
  );
}